import { message } from 'antd';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'

import { history } from "../../../appRedux/store";
import { unlockVisitAPI } from '../../../services/locked-visits-service';
import { getForTypingAutoNextVisitAPI, getPatientHistoryReportsAPI, getTypistAutoNextParkedVisitAPI, getVisitReportAPI, updateDictationReportAPI } from '../../../services/typist-service';
import { FETCH_PATIENT_HISTORY_REPORTS, FETCH_PATIENT_HISTORY_REPORTS_ERROR, FETCH_PATIENT_HISTORY_REPORTS_START, FETCH_PATIENT_HISTORY_REPORTS_SUCCESS, UNLOCK_REPORT_EDITOR_VISIT, UNLOCK_REPORT_EDITOR_VISIT_ERROR, UNLOCK_REPORT_EDITOR_VISIT_START, UNLOCK_REPORT_EDITOR_VISIT_SUCCESS, UPDATE_DICTATION_REPORT, UPDATE_DICTATION_REPORT_ERROR, UPDATE_DICTATION_REPORT_START, UPDATE_DICTATION_REPORT_SUCCESS, RESET_REPORT_EDITOR, SKIP_CURRENT_AND_VIEW_NEXT_VISIT } from '../../actions/typist/reportEditorAction';
import { UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS } from '../../actions/typist/typistSubmittedAction';
import { fetchRadiologistTemplates, UNLOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS, VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR, VIEW_SUBMITTED_FOR_TYPING_VISIT_START, VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS } from '../../actions/typist/typistWorklistAction';
import { setSessionDataByKey, SET_USER_SESSION_DATA_BY_KEY } from '../../actions/userLocalStorageSession';
import { SET_VISIT_LOCK } from '../../actions/activityAction';
import { VISIT_STATES } from '../../../constants/constants';
const getAuthState = (state) => state.auth;
const getTypistWorklist = (state) => state.typist.worklist;
const getTypistParked = (state) => state.typist.typistParked;

function* setVisitLock(visit) {
    if (visit !== null) {
        return yield put({
            type: SET_VISIT_LOCK,
            selectedVisit: {
                isVisitLocked: true,
                reportId: visit.reportId
            }
        })
    } else {
        return yield put({
            type: SET_VISIT_LOCK,
            selectedVisit: {
                isVisitLocked: false,
                reportId: null
            }
        })
    }
}

function* updateDictationReport({ payload }) {
    try {
        const { dictationReport, autoNextConfig } = payload;
        yield put({ type: UPDATE_DICTATION_REPORT_START })
        const response = yield call(updateDictationReportAPI, dictationReport);
        if (response.success) {
            if(dictationReport.state === VISIT_STATES.P){
                message.success(`Dictation report parked successfully.`);
            }else if(dictationReport.state === VISIT_STATES.SFV){
                message.success(`Dictation report submitted to radiologist successfully.`);
            }
            yield put({ type: UPDATE_DICTATION_REPORT_SUCCESS, visit: response.visit });
            if (dictationReport.state === VISIT_STATES.SFV || dictationReport.state === VISIT_STATES.P) {
                if (autoNextConfig && autoNextConfig.autoNextVisit) {
                    yield call(viewNextVisit, autoNextConfig, dictationReport);
                } else {
                    yield call(setVisitLock, null);
                    if (dictationReport.state === VISIT_STATES.SFV) {
                        history.goBack();
                    }
                }
            } else {
                yield call(setVisitLock, null);
            }
        } else {
            if (response.error) {
                yield put({ type: UPDATE_DICTATION_REPORT_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: UPDATE_DICTATION_REPORT_ERROR, error: response.error })
                message.error('Failed to save/submit dictation report!');
            }
        }
    } catch (error) {
        yield put({ type: UPDATE_DICTATION_REPORT_ERROR, error })
        message.error('Failed to save/submit dictation report!');
    }
}

function* viewNextVisit(autoNextConfig = { prevLocation: '/typ/for-typing' }, currentVisit = null) {
    try {
        yield put({ type: RESET_REPORT_EDITOR });
        yield put({ type: VIEW_SUBMITTED_FOR_TYPING_VISIT_START });
        const { sessionData } = yield select(getAuthState);
        let skippedVisits = [];
        if (autoNextConfig.prevLocation === '/typ/parked') {
            if (sessionData && sessionData.typ_p_skv) {
                skippedVisits = sessionData.typ_p_skv.map(v => v.reportId)
            }
            if (currentVisit && currentVisit.reportId && !skippedVisits.includes(currentVisit.reportId)) {
                skippedVisits = [...skippedVisits, currentVisit.reportId];
            }
            const { searchFilter, sortConditions, pagination } = yield select(getTypistParked);
            const response = yield call(getTypistAutoNextParkedVisitAPI, {
                searchFilter,
                sortConditions,
                skippedVisits,
                page: pagination.currentPage,
                size: pagination.pageSize,
            });
            if (response.success) {
                if (response.data && response.data.visit) {
                    const { visit, dictation, dictations } = response.data;
                    yield put({
                        type: VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS,
                        report: {
                            ...response.data,
                            visit,
                            dictations: dictations ? dictations : (dictation ? [dictation] : [])
                        }
                    });
                    return;
                }
                message.info("Next visit not found!");
                history.goBack();
            } else {
                yield put({ type: VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR, error: response.error })
                message.error(response.error || 'Failed to view next visit!');
                history.goBack();
            }
            return;
        }

        if (sessionData && sessionData.typ_ft_skv) {
            skippedVisits = sessionData.typ_ft_skv.map(v => v.reportId)
        }
        const { searchFilter, sortConditions } = yield select(getTypistWorklist);
        const response = yield call(getForTypingAutoNextVisitAPI, { searchFilter, sortConditions, skippedVisits });
        if (response.success) {
            if (response.data) {
                const { visit, dictation } = response.data;
                yield put({
                    type: VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS,
                    report: {
                        visit,
                        dictations: dictation ? [dictation] : []
                    }
                });
                if (visit && visit.state === VISIT_STATES.P) {
                    yield call(setVisitLock, null);
                } else {
                    yield call(setVisitLock, visit);
                }
                // yield put(fetchRadiologistTemplates(visit.radiologistCode));
            } else {
                message.info("Next visit not found!");
                yield call(setVisitLock, null);
                history.goBack();
            }
        } else {
            if (response.error) {
                yield put({ type: VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR, error: response.error })
                message.error(response.error);
            } else {
                yield put({ type: VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR, error: response.error })
                message.error('Failed to view next visit!');
            }
            yield call(setVisitLock, null);
            history.goBack();
        }
    } catch (error) {
        yield put({ type: VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR, error })
        message.error('Failed to view next visit!');
        history.goBack();
    }
}

function* unlockVisit({ payload }) {
    try {
        const { visit, onConfirm, from } = payload;
        yield put({ type: UNLOCK_REPORT_EDITOR_VISIT_START })
        const response = yield call(unlockVisitAPI, visit.reportId);
        if (response.success) {
            yield call(setVisitLock, null);
            yield put({ type: UNLOCK_REPORT_EDITOR_VISIT_SUCCESS })
            switch (from) {
                case "/typ/for-typing":
                    yield put({ type: UNLOCK_SUBMITTED_FOR_TYPING_VISIT_SUCCESS, visit })
                    break;
                case "/typ/submitted":
                    yield put({ type: UNLOCK_SUBMITTED_FOR_VERIFICATION_VISIT_SUCCESS, visit })
                    break;
                default:
                    break;
            }
            onConfirm();
        } else {
            onConfirm();
            if (response.error) {
                message.error(response.error);
                yield put({ type: UNLOCK_REPORT_EDITOR_VISIT_ERROR, error: response.error })
            } else {
                message.error('Failed to unlock visit!');
            }
        }
    } catch (error) {
        yield put({ type: UNLOCK_REPORT_EDITOR_VISIT_ERROR, error })
        message.error('Failed to unlock visit!');
    }
}

function* skipCurrentAndLoadNextVisit({ payload }) {
    try {
        const { authUser, sessionData } = yield select(getAuthState);
        const { visit, autoNextConfig } = payload;
        const { reportId, risId, risCode, visitNo } = visit;
        const shouldUnlockVisit = !autoNextConfig ||
            (autoNextConfig.prevLocation !== '/typ/parked' && !autoNextConfig.isParkedVisit);
        let response = { success: true };
        if (shouldUnlockVisit) {
            yield put({ type: UNLOCK_REPORT_EDITOR_VISIT_START })
            response = yield call(unlockVisitAPI, reportId);
        }
        if (response.success) {
            if (shouldUnlockVisit) {
                yield put({ type: UNLOCK_REPORT_EDITOR_VISIT_SUCCESS });
            }
            const skipKey = autoNextConfig && autoNextConfig.prevLocation === '/typ/parked' ? 'typ_p_skv' : 'typ_ft_skv';
            const skippedVisitList = sessionData && sessionData[skipKey] ? sessionData[skipKey] : [];
            let skv = {
                "reportId": reportId,
                "visitNo": visitNo,
                "risId": risId,
                "risCode": risCode,
            };
            let data;
            let index = -1;
            index = skippedVisitList.findIndex(v=> v.reportId === reportId);
            if(index < 0){
                data = [...skippedVisitList, skv];
            }else{
                data = [...skippedVisitList];
            }
            const payload = {
                key: skipKey,
                value: data
            };
            setSessionDataByKey(authUser.email, payload);
            yield put({ type: SET_USER_SESSION_DATA_BY_KEY, payload });
            yield call(viewNextVisit, autoNextConfig, visit);
        } else {
            if (response.error) {
                message.error(response.error);
                yield put({ type: UNLOCK_REPORT_EDITOR_VISIT_ERROR, error: response.error })
            } else {
                message.error(`Failed to unlock visit ${visitNo}!`);
            }
        }
    } catch (error) {
        console.log(error);
        yield put({ type: UNLOCK_REPORT_EDITOR_VISIT_ERROR, error })
        message.error('Failed to unlock visit!');
    }
}

function* getVisitReportForNext(visit) {
    const response = yield call(getVisitReportAPI, visit.risId, visit.reportId, visit.visitNo);
    if (response.success) {
        const dictations = response.visitReport && response.visitReport.dictations ? response.visitReport.dictations : [];
        yield put({
            type: VIEW_SUBMITTED_FOR_TYPING_VISIT_SUCCESS,
            report: {
                ...response.visitReport,
                dictations
            }
        });
        yield call(setVisitLock, visit);
        return true;
    }
    yield put({ type: VIEW_SUBMITTED_FOR_TYPING_VISIT_ERROR, error: response.error })
    message.error(response.error || 'Failed to view next visit!');
    return false;
}

function* fetchPatientHistoryReports({ visit }) {
    try {
        const { reportId, visitNo, patientId } = visit;
        yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_START })
        const response = yield call(getPatientHistoryReportsAPI, patientId);
        if (response.success) {
            const filteredPatientHistoryReports = response.patientHistoryReports.filter(report => report.visit.reportId !== reportId && report.visit.visitNo !== visitNo);
            yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_SUCCESS, patientHistoryReports: filteredPatientHistoryReports })
        } else {
            yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_ERROR })
            message.error('Failed to fetch patient history reports!');
        }
    } catch (error) {
        yield put({ type: FETCH_PATIENT_HISTORY_REPORTS_ERROR, error })
        message.error('Failed to fetch patient history reports!');
    }
}

function* reportEditorWatcher() {
    yield takeLatest(UPDATE_DICTATION_REPORT, updateDictationReport)
    yield takeLatest(UNLOCK_REPORT_EDITOR_VISIT, unlockVisit)
    yield takeLatest(SKIP_CURRENT_AND_VIEW_NEXT_VISIT, skipCurrentAndLoadNextVisit)
    yield takeLatest(FETCH_PATIENT_HISTORY_REPORTS, fetchPatientHistoryReports)
}

export default function* rootSaga() {
    yield all([
        reportEditorWatcher(),
    ]);
}
